/**
 * Validates a name to ensure it contains only alphabetic characters, spaces, hyphens, apostrophes, and accented characters.
 *
 * @param {string} name - The name to validate.
 * @returns {boolean} Returns true if the name is valid, otherwise false.
 */
const validateName = (name: string): boolean => {
  const regexpName = /^[A-Za-zÀ-ÖØ-öø-ÿ\s'-]*$/;

  return regexpName.test(name);
};

export default validateName;
